import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    selector: 'app-done-message',
    templateUrl: './done-message.component.html',
    styleUrls: ['./done-message.component.scss'],
    standalone: false
})
export class DoneMessageComponent implements OnInit {
  header: string = this.translate.instant('general.done');
  text: string = this.translate.instant('general.success-message');

  constructor(
    protected dialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private translate: TranslateService,
  ) {
    this.header = this.dynamicDialogConfig.data?.['header'];
    this.text = this.dynamicDialogConfig.data?.['text'];
  }

  ngOnInit(): void {}
  ok() {
    this.dialogRef.close();
  }
  close() {
    this.dialogRef.close(false);
  }
}
